import { render } from "./AddRecipientsModalBulk.vue?vue&type=template&id=3c928600&scoped=true"
import script from "./AddRecipientsModalBulk.vue?vue&type=script&lang=js"
export * from "./AddRecipientsModalBulk.vue?vue&type=script&lang=js"

import "./AddRecipientsModalBulk.vue?vue&type=style&index=0&id=3c928600&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c928600"]])

export default __exports__